import React, { Component } from 'react';
import { Button, Divider, Dropdown, DropdownItemProps, DropdownProps, Grid, Header, Icon, Input, InputOnChangeData, Modal, SemanticCOLORS, Pagination, PaginationProps } from 'semantic-ui-react';
import { strings } from '../..';
import { Anagrafica, Moduli } from '../../core';
import { TipoIntervento } from '../../core-assistenza';
import { datetimeFormatter, getIconName } from '../../core/utility';
import { Chiamata, StatoFiltroChiamate } from '../models';
import { allStatiFiltroValues } from '../utility';
import { numeroDocumentoFormatterMobile, statoChiamataFormatter, tipoInterventoFormatter, dettagliFormatter } from './Formatters';
import parse from 'html-react-parser';

type ElencoSegnalazioniMobileProps = {
    chiamate: ReadonlyArray<Chiamata>,
    page: number,
    pageSize: number,
    itemsCount: number,
    anagrafica: Anagrafica,
    moduli: Moduli,
    isTablet: boolean,
    loadChiamate: (search: string, page: number, tipoIntervento?: TipoIntervento, stato?: number) => void,
    downloadFile: (idArchivio: string) => void
}

type ElencoSegnalazioniMobileState = {
    filtroOpen: boolean,
    search: string,
    stato?: StatoFiltroChiamate,
    tipoIntervento?: TipoIntervento
}

export default class ElencoSegnalazioniMobile extends Component<ElencoSegnalazioniMobileProps, ElencoSegnalazioniMobileState> {
    constructor(props: ElencoSegnalazioniMobileProps) {
        super(props);

        this.state = {
            filtroOpen: false,
            search: '',
            stato: StatoFiltroChiamate.Aperta,
        };
    }

    componentDidMount() {
        const { page } = this.props;

        this.onSearch(page);
    }

    render() {
        const { chiamate, anagrafica } = this.props;
        const filtroColor: SemanticCOLORS | undefined = 
            this.state.stato !== undefined || this.state.tipoIntervento !== undefined ? 
                'orange' : 
                undefined;
        const renderChiamata = this.props.isTablet ?
            this.renderChiamataTablet :
            this.renderChiamataMobile;

        return (
            <Grid centered>
                <Grid.Row>
                    <Header as='h2' textAlign='center'>
                        <Icon name='warning sign' />
                        <Header.Content>
                            {strings.chiamate.elenco.titolo}
                            <Header.Subheader>{anagrafica.ragioneSociale}</Header.Subheader>
                        </Header.Content>
                    </Header>
                </Grid.Row>
                <Grid.Row>
                    <Grid.Column width='13'>
                        <Input
                            fluid
                            icon={<Icon onClick={this.onSearchClick} name="search" inverted circular link />}
                            placeholder="Ricerca..."
                            value={this.state.search}
                            onChange={this.onSearchChange}
                        />
                    </Grid.Column>
                    <Grid.Column width='2'>
                        <Button primary icon onClick={this.azioneFiltroAvanzato}>
                            <Icon name='filter' color={filtroColor} />
                        </Button>
                        {this.renderFiltro()}
                    </Grid.Column>
                </Grid.Row>
                {chiamate.map(renderChiamata)}
                {this.renderPaginazione()}
            </Grid>
        );
    }

    renderFiltro = () => {
        const optionsTipiIntervento: DropdownItemProps[] = [
            { key: TipoIntervento.Hardware, value: TipoIntervento.Hardware, text: 'Intervento hardware' },
            { key: TipoIntervento.Software, value: TipoIntervento.Software, text: 'Intervento software' }
        ];

        const optionsStati: DropdownItemProps[] = allStatiFiltroValues.map(stato => ({
            key: stato.stato,
            value: stato.stato, 
            text: stato.text, 
            content: <><Icon name={stato.name} color={stato.color} /> {stato.text}</>
        }));

        return (
            <Modal open={this.state.filtroOpen} onClose={this.azioneFiltroAvanzato} closeOnDimmerClick={false}>
                <Header icon='filter' content='Filtri avanzati' />
                <Modal.Content>
                    <Grid>
                        <Grid.Row centered>
                            <Grid.Column width='15'>
                                <label>Seleziona lo stato</label>
                                <Dropdown 
                                    selection 
                                    clearable 
                                    fluid 
                                    placeholder='Stato...'
                                    defaultValue={this.state.stato} 
                                    options={optionsStati} 
                                    onChange={this.onStatoChange} 
                                />
                            </Grid.Column>
                        </Grid.Row>
                        <Grid.Row centered>
                            <Grid.Column width='15'>
                                <label>Seleziona il tipo intervento</label>
                                <Dropdown 
                                    selection 
                                    clearable 
                                    fluid 
                                    placeholder='Tipo intervento...' 
                                    defaultValue={this.state.tipoIntervento} 
                                    options={optionsTipiIntervento} 
                                    onChange={this.onTipoInterventoChange} 
                                />
                            </Grid.Column>
                        </Grid.Row>
                    </Grid>
                </Modal.Content>
                <Modal.Actions>
                    <Button color='green' onClick={this.onSearchClick}>
                        <Icon name='checkmark' /> 
                        Conferma
                    </Button>
                </Modal.Actions>
            </Modal>
        );
    }

    renderChiamataMobile = (chiamata: Chiamata) => {
        return (
            <React.Fragment key={chiamata.idChiamata}>
                <Grid.Row>
                    <Grid.Column width='14'>
                        <Grid>
                            <Grid.Row>
                                <Grid.Column width='4'><b>{tipoInterventoFormatter(chiamata.tipoIntervento)}</b></Grid.Column>
                                <Grid.Column width='7'>del <b>{datetimeFormatter(chiamata.data)}</b></Grid.Column>
                                <Grid.Column width='5' textAlign='right'>{numeroDocumentoFormatterMobile(chiamata.numero)}</Grid.Column>
                            </Grid.Row>
                            <Grid.Row style={{ padding: 3 }}>
                                <Grid.Column width='3'><b>{chiamata.numeroMacchina}</b></Grid.Column>
                                <Grid.Column width='6'>{chiamata.codice}</Grid.Column>
                                <Grid.Column width='7' textAlign='right'>{chiamata.descrizione}</Grid.Column>
                            </Grid.Row>
                            {
                                chiamata.ubicazione !== "" &&
                                <Grid.Row style={{ padding: 3 }}>
                                    <Grid.Column width='2' verticalAlign='middle'><Icon color='green' name='map marker alternate'/></Grid.Column>
                                    <Grid.Column width='14' verticalAlign='middle'> {parse(chiamata.ubicazione)}</Grid.Column>
                                </Grid.Row>
                            }
                            <Grid.Row style={{ padding: 3 }}>
                                <Grid.Column width='9'>{chiamata.tipoRichiesta}</Grid.Column>                                
                                <Grid.Column width='7' textAlign='right'>{statoChiamataFormatter(chiamata.stato, chiamata)}</Grid.Column>
                            </Grid.Row>
                        </Grid>
                    </Grid.Column>
                    <Grid.Column width='2' stretched verticalAlign='middle' textAlign='center'>
                        {dettagliFormatter(chiamata, chiamata)}
                        {this.props.moduli.chiamateArchivi && <Divider hidden />}
                        {this.props.moduli.chiamateArchivi && this.formatoDocumentoFormatter(chiamata.fileName, chiamata)}
                    </Grid.Column>
                </Grid.Row>
                <Divider fitted />
            </React.Fragment >
        );
    }

    renderChiamataTablet = (chiamata: Chiamata) => {
        const columnWidth = this.props.moduli.chiamateArchivi ? 13 : 15;

        return (
            <React.Fragment key={chiamata.idChiamata}>
                <Grid.Row>
                    <Grid.Column width={columnWidth}>
                        <Grid>
                            <Grid.Row style={{ height: 30 }}>
                                <Grid.Column width='2'><b>{tipoInterventoFormatter(chiamata.tipoIntervento)}</b></Grid.Column>
                                <Grid.Column width='4'>del <b>{datetimeFormatter(chiamata.data)}</b></Grid.Column>
                                <Grid.Column width='5'>{numeroDocumentoFormatterMobile(chiamata.numero)}</Grid.Column>
                                <Grid.Column width='5'>{statoChiamataFormatter(chiamata.stato, chiamata)}</Grid.Column>
                            </Grid.Row>
                            <Grid.Row>
                                <Grid.Column width='2'><b>{chiamata.numeroMacchina}</b></Grid.Column>
                                <Grid.Column width='4'>{chiamata.codice}</Grid.Column>
                                <Grid.Column width='5'>{chiamata.descrizione}</Grid.Column>
                                <Grid.Column width='5'>{chiamata.tipoRichiesta}</Grid.Column>
                            </Grid.Row>
                        </Grid>
                    </Grid.Column>
                    <Grid.Column width='1' verticalAlign='middle'>
                        {dettagliFormatter(chiamata, chiamata)}
                    </Grid.Column>
                    {this.props.moduli.chiamateArchivi && this.renderColonnaArchiviazioneTablet(chiamata)}
                </Grid.Row>
                <Divider fitted />
            </React.Fragment >
        );
    }

    renderColonnaArchiviazioneTablet = (chiamata: Chiamata) => (
        <Grid.Column width='1' stretched verticalAlign='middle' textAlign='center'>
            {this.formatoDocumentoFormatter(chiamata.fileName, chiamata)}
        </Grid.Column>
    )

    renderPaginazione = () => {        
        const { itemsCount, page, pageSize } = this.props;
        const pageCount = Math.ceil(itemsCount / pageSize);

        return (
            <Grid.Row>
                <Pagination 
                    activePage={page}
                    totalPages={pageCount}
                    onPageChange={this.onPageChanged}
                    firstItem={null}
                    lastItem={null}
                />
            </Grid.Row>
        );
    }

    azioneFiltroAvanzato = () => {
        this.setState({ filtroOpen: !this.state.filtroOpen });
    }

    onSearchChange = (_: React.ChangeEvent<HTMLInputElement>, data: InputOnChangeData) => {
        this.setState({ search: data.value });
    }

    onPageChanged = (_: React.MouseEvent<HTMLAnchorElement>, data: PaginationProps) => {
        const page = Number(data.activePage);
        this.onSearch(page);
    }

    onStatoChange = (_: React.SyntheticEvent<HTMLElement, Event>, data: DropdownProps) => {
        const stato = data.value === '' ? undefined : data.value as StatoFiltroChiamate;
        this.setState({ stato: stato });
    }

    onTipoInterventoChange = (_: React.SyntheticEvent<HTMLElement, Event>, data: DropdownProps) => {
        const tipoIntervento = data.value === '' ? undefined : data.value as TipoIntervento;
        this.setState({ tipoIntervento: tipoIntervento });
    }

    onSearchClick = () => {
        this.setState({ filtroOpen: false });
        this.onSearch(this.props.page);
    }

    onSearch = (page: number) => {
        const { search, tipoIntervento, stato } = this.state;
        this.props.loadChiamate(search, page, tipoIntervento, stato);
    }

    onFileClick = (_: any, data: any) => {
        this.props.downloadFile(String(data.id));
    }

    formatoDocumentoFormatter = (value: any, item: Chiamata): JSX.Element => {
        if (item.idArchivio === null) {
            return <></>;
        }
    
        const icon = getIconName(String(value));
        return (
            <Icon size='large' link name={icon.name} color={icon.color} onClick={this.onFileClick} id={item.idArchivio} />
        );
    }
}
